/* OMBA: gift bridge for the existing cart, using Kaching's published deal configuration.
   No change to catalog prices or artificial stock; Shopify validates the final discount. */
(function (global) {
  'use strict';
  const lineId = item => Number(item.variant_id || item.id);
  const parse = item => { try { return JSON.parse(item.properties?.__kaching_bundles || 'null'); } catch (_) { return null; } };
  const configFor = productId => {
    const node = document.querySelector('script.kaching-bundles-deal-block-settings[data-product-id="'+productId+'"]');
    if (!node) throw new Error('No pudimos confirmar el regalo. Recarga la página para continuar.');
    const cfg = JSON.parse(node.textContent);
    if (!cfg.id || !cfg.nanoId || !cfg.versionId || !Array.isArray(cfg.dealBars)) throw new Error('La oferta se está actualizando. Recarga la página.');
    return cfg;
  };
  function itemsFor(cfg, options) {
    const {variantId, productId, quantity, giftVariantId, giftProductId, totalCents} = options;
    const bar = cfg.dealBars.find(b => b.quantity === quantity);
    if (!bar || bar.discountType !== 'specific' || Math.round(bar.discountValue * 100) !== totalCents || cfg.priceRounding) throw new Error('La oferta cambió. Recarga la página antes de comprar.');
    const gift = (bar.freeGifts || []).find(g => Number(g.productGID.split('/').pop()) === giftProductId && g.quantity === 1);
    if (quantity >= 4 && !gift) throw new Error('No pudimos confirmar el regalo de este pack.');
    const common = {id:'omba-'+variantId, deal:cfg.nanoId, v:cfg.versionId};
    const items = [{id:variantId, quantity, properties:{__kaching_bundles:JSON.stringify({...common,pp:productId,main:true,bid:bar.id})}}];
    if (gift) items.push({id:giftVariantId,quantity:1,properties:{_omba_pack_gift:String(variantId),__kaching_bundles:JSON.stringify({...common,gift:gift.id})}});
    return items;
  }
  async function sync(request, options) {
    const cfg = configFor(options.productId), desired = itemsFor(cfg, options);
    let cart = await request('cart.js',undefined,'GET');
    const main = (cart.items || []).filter(i => lineId(i) === options.variantId);
    const gifts = (cart.items || []).filter(i => i.properties?._omba_pack_gift === String(options.variantId));
    const sameMain = main.length === 1 && main[0].quantity === options.quantity && main[0].properties?.__kaching_bundles === desired[0].properties.__kaching_bundles;
    const sameGift = desired.length === 2 ? gifts.length === 1 && lineId(gifts[0]) === options.giftVariantId && gifts[0].quantity === 1 && gifts[0].properties?.__kaching_bundles === desired[1].properties.__kaching_bundles : gifts.length === 0;
    if (!sameMain || !sameGift) {
      // Remove only this pack's managed gift; independently purchased sprays stay intact.
      if (gifts.length) await request('cart/update.js',{updates:Object.fromEntries(gifts.map(i => [i.key,0]))});
      if (main.length === 1) {
        await request('cart/change.js',{id:main[0].key,quantity:options.quantity,properties:{...main[0].properties,...desired[0].properties}});
      } else {
        if (main.length) await request('cart/update.js',{updates:Object.fromEntries(main.map(i => [i.key,0]))});
        await request('cart/add.js',{items:[desired[0]]});
      }
      if (desired.length === 2) await request('cart/add.js',{items:[desired[1]]});
    }
    cart = await request('cart.js',undefined,'GET');
    const codes = global.OMBACartRegistry.codes(cart);
    cart = await request('cart/update.js',{discount:codes.join(',')});
    validate(cart,options);
    return cart;
  }
  function validate(cart, options) {
    const main = (cart.items || []).filter(i=>lineId(i)===options.variantId);
    const gifts = (cart.items || []).filter(i=>i.properties?._omba_pack_gift===String(options.variantId));
    if (main.reduce((s,i)=>s+i.quantity,0)!==options.quantity || main.reduce((s,i)=>s+i.final_line_price,0)!==options.totalCents) throw new Error('No pudimos confirmar el precio del pack. Reintenta antes de pagar.');
    if (options.quantity>=4) {
      if (gifts.length!==1 || gifts[0].quantity!==1 || lineId(gifts[0])!==options.giftVariantId || gifts[0].final_line_price!==0) throw new Error('El regalo todavía no se descontó. Reintenta antes de pagar.');
    } else if (gifts.length) throw new Error('El regalo no corresponde a este pack. Confirma de nuevo tu selección.');
    return true;
  }
  global.OMBAPackGift = {itemsFor,sync,validate,parse};
})(typeof window==='undefined'?globalThis:window);
